// src/data/strengths.js
// 메디로이어 강점 섹션 데이터. 각 강점은 관련 오킴스 사례글(/cases/:slug)로 연결된다.

export const strengthsData = [
  {
    slug: 'dual-expertise',
    title: '의료인 출신 변호사',
    desc: '의학과 법학 양쪽을 이해합니다. 임상 기준으로 직접 과실을 판단할 수 있는 팀은 드뭅니다.',
    caseSlug: 'case-dental-scams',
    caseLabel: '관련 사례: 투명치과·이편한치과 사건',
  },
  {
    slug: 'social-cases',
    title: '사회적 이슈 의료사건 수행',
    desc: '인보사·맘모톰·앨러간 유방보형물·산후조리원 영아 사망 사건 등 대형 의료 이슈를 실제 수행한 경험.',
    caseSlug: 'case-social-issues',
    caseLabel: '관련 사례: 인보사·맘모톰 사건',
  },
  {
    slug: 'certified',
    title: '대한변협 인증 전문 변호사',
    desc: '대한변호사협회 의료법·형사법 이중 전문 인증. 협회가 검증한 실전 경험.',
    caseSlug: 'case-certified-track',
    caseLabel: '관련 사례: 전문 인증 수행 사건',
  },
  {
    slug: 'partner-network',
    title: '의료인 단체 공식 파트너',
    desc: '대한치과의사협회·서울시치과의사회·대한외과의사회 공식 고문·협력 변호사.',
    caseSlug: 'case-association-work',
    caseLabel: '관련 사례: 단체 자문 프로젝트',
  },
  {
    slug: 'industry-depth',
    title: '산업 깊이의 기업자문',
    desc: '제약·바이오·의료기기·디지털헬스케어 M&A와 라이센싱 자문까지 하나의 팀에서.',
    caseSlug: 'case-biotech-deals',
    caseLabel: '관련 사례: 바이오벤처 투자·M&A 자문',
  },
];

export function getStrengthBySlug(slug) {
  return strengthsData.find((s) => s.slug === slug);
}
